module.exports = __webpack_public_path__ + "media/black_belt_center.dd4c2792.mp3";